var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{staticClass:"json-viewer"},[_vm._v(_vm._s(JSON.stringify(_vm.resultSet, null, 2)))])}
var staticRenderFns = []

export { render, staticRenderFns }